import { Modal, noop } from '@iqueue/ui-kit'
import ErrorView from './errors/ErrorView'
import { t } from '../hooks/useTranslate'

export default async function Prompt(question, {
  danger = false, onApply = noop, onCancel = noop,
}) {
  try {
    return await Modal
      .show({
        title: t('prompt.title'),
        children: () => <h5>{ question } </h5>,
        errorView: ErrorView,
        onApply,
        onCancel,
        footerActions: [{
          key: 'apply',
          submit: true,
          primary: !danger,
          danger: danger,
          title: t('prompt.yes'),
        }, {
          key: 'cancel',
          primary: danger,
          danger: !danger,
          title: t('prompt.no'),
        }],
      })
  } catch (ignored) {
    return false
  }
}
